import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

// The Downloads page itself is public — this guard only exists to make sure
// Firebase auth state has resolved before the page renders, so the
// per-item access checks (auth.canAccessLevelData, auth.isToolAllowed)
// don't briefly evaluate against default/unloaded state.
@Injectable({ providedIn: 'root' })
export class DownloadsGuard implements CanActivate {
  constructor(private auth: AuthService) {}

  async canActivate(): Promise<boolean> {
    await this.auth.ensureReady();
    await firstValueFrom(this.auth.loading$.pipe(filter((loading) => !loading)));
    return true;
  }
}
